import { NgModule } from '@angular/core';
import { AdminRoutingModule } from './admin-routing.module';
import { SideNavService } from 'src/app/shared/side-nav/services/side-nav.service';
import { adminSideNavConfig } from './admin-side-nav.config';


@NgModule({
  declarations: [],
  imports: [
    AdminRoutingModule 
  ]
})

export class AdminModule { 
  constructor(sideNavService: SideNavService) {
    sideNavService.addSubMenuItems('admin', adminSideNavConfig)
  }
}
